import { KalturaAssetHistory } from '@kaltura-ott/ott-client-types/api/types';

import { KuxBookmark } from '../interfaces/bookmarks';

export const assetHistoryToKuxBookmark = (assetHistory: KalturaAssetHistory): KuxBookmark => {
  // Note: duration always in seconds! Sometimes it goes from ingest in ms, in this case it wrong time and we ignore it
  return {
    assetId: assetHistory.assetId,
    duration: assetHistory.duration,
    position: assetHistory.position,
    finishedWatching: assetHistory.finishedWatching,
    watchedDate: assetHistory.watchedDate,
  };
};
